import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WIDGET_FEATURE_KEY } from './widget.reducer';
import { StoreGroup, StoreTemplateStatus, StoreWidget, StoreWidgetState, WidgetState } from '@pt/pt-models';
import { WidgetActionsUtils } from '../utils/widget-actions-utils';

export const selectWidgetModuleState = createFeatureSelector<WidgetState>(WIDGET_FEATURE_KEY);

export const getChapter = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.chapter;
});

export const getChapters = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.chapters?.chapters || [];
});

export const getChapterGroups = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.chapter?.payload?.groups;
});
export const currentLanguage = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.currentLanguage;
});

export const getTrigger = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.chapter?.payload?.trigger;
});

export const getDocInfo = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.docInfo;
});
export const getActiveChapterInfo = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.activeChapter;
});

export const lockEnabled = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.lockEnabled;
});

export const getDocumentPermission = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.documentPermission;
});

export const getViewMode = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.viewMode;
});

export const requireReloadResult = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state.requireReloadResult;
});

export const getWidgets = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return WidgetActionsUtils.getWidgetFromTemplateGroups(state?.chapter?.payload?.groups);
});

export const getStoreWidgets = createSelector(selectWidgetModuleState, (state: WidgetState) => {
  return state?.widgets;
});

export const getWidgetsStatus = createSelector(
  selectWidgetModuleState,
  (state: WidgetState) => {
    const validWidgetId = [];
    const loadedWidgetId = [];
    const errorWidgetId = [];
    const enabledWidgetId = [];
    let activedEditWidgetId: number = null;
    let loadedGroupId = state.groups.map((g: StoreGroup) => g.id);
    let validGroupId = state.groups.map((g: StoreGroup) => g.id);
    let totalWidget = 0;
    // const hiddenWidgetId = [];
    state?.chapter?.payload?.groups?.forEach((group) => {
      // if (group.hidden) {
      //   hiddenWidgetId.push(...group.widgets.map(w => w.internalId))
      // }
      //Filter HTML widget because is always readonly so always completed
      if (group.enabled) {
        totalWidget += group.widgets.filter(w => w.enabled).length;
      }
    });

    let initializedTemplate = state?.widgets?.length > 0;


    state?.widgets?.forEach((storeWidget: StoreWidget) => {
      if (storeWidget.isActivedEditMode) {
        activedEditWidgetId = storeWidget.internalId;
      }

      if (storeWidget.enabled) {
        enabledWidgetId.push(storeWidget.internalId);

        // la seconda condizione evita che nei widget totali ci siano anche quelli presenti nei gruppi nascosti
        if (storeWidget.isValid) {
          validWidgetId.push(storeWidget.internalId);
        } else {
          validGroupId = validGroupId.filter((id: number) => storeWidget.groupId !== id);
        }

      }




      switch (storeWidget.state) {
        case StoreWidgetState.COMPLETED:
          loadedWidgetId.push(storeWidget.internalId);
          break;

        case StoreWidgetState.ERROR:
          loadedWidgetId.push(storeWidget.internalId);
          errorWidgetId.push(storeWidget.internalId);
          break;

        case StoreWidgetState.REGISTERED:
        case StoreWidgetState.INITIALIZATION:
        case StoreWidgetState.GLOBAL_INITIALIZATION:
          initializedTemplate = false;
          loadedGroupId = loadedGroupId.filter((groupId: number) => storeWidget.groupId !== groupId);
          break;

        case StoreWidgetState.TRIGGER_RUNNING:
          initializedTemplate = false;
          break;
        default:
          console.error('Not found status ', storeWidget.state);
      }
    });

    const activedEditTreatment = state.editItemActive;

    return {
      totalWidget,
      enabledWidgetId,
      validWidgetId,
      errorWidgetId,
      validGroupId,
      loadedGroupId,
      loadedWidgetId,
      editorReady: initializedTemplate,
      activedEditTreatment,
      activedEditWidgetId,
      documentEditorNotification: state.documentEditorNotifications
    } as StoreTemplateStatus;
  });
export const getStoreWidget = createSelector(selectWidgetModuleState, (state: WidgetState) => state?.widgets);
export const autosave = createSelector(selectWidgetModuleState, (state: WidgetState) => state?.chapter?.payload?.autoSave);

export const widgetNotifications = createSelector(selectWidgetModuleState, (state: WidgetState) => state?.widgetNotifications);

export const warnings = createSelector(selectWidgetModuleState, (state: WidgetState) => state?.warnings);
